const login = resolve => require(['../view/user/login'], resolve)
const reg = resolve => require(['../view/user/reg'], resolve)
const invReg = resolve => require(['../view/user/invReg'], resolve)
const forget = resolve => require(['../view/user/forget'], resolve)
const routes = [
  {
    path: '/user/login',
    name: '/user/login',
    component: login,
    meta: {
    }
  },{
    path: '/user/reg',
    name: '/user/reg',
    component: reg,
    meta: {
    }
  },{
    path: '/user/invReg',
    name: '/user/invReg',
    component: invReg,
    meta: {
    }
  },{
    path: '/user/forget',
    name: '/user/forget',
    component: forget,
    meta: {
    }
  },]
export default {routes}



// WEBPACK FOOTER //
// ./src/router/user.js